const buildQuery = (
  name,
  brand,
  primaryCategories,
  GTIN,
  SKUS,
  brandManufacturer,
  taxonomyLevel1,
  taxonomyLevel2,
  taxonomyLevel3,
  rawCategory,
  rentalPrice,
  mostRecentPriceDate,
  description,
  recordRecency,
  featureKeyword,
  requiredFields,
  reviewsRangeQuery,
  domain,
  mostRecentPriceIsSale,
  taxonomy,
  price,
  priceWarranty,
  categoryWildCard,
  color,
  categoriesWithParenthesis,
  featuresWithKey,
  manufacturerNumber
) => {
  let queryParts = []

  if (name) {
    let nameQuery = `name:"${name}"`
    queryParts.push(nameQuery)
  }
 
  if (brand) {
    let nameQuery = `brand:"${brand}"`
    queryParts.push(nameQuery)
  }

  // Handling primaryCategories
  if (primaryCategories && primaryCategories.some(pt => pt !== 'Any')) {
    const filteredCategories = primaryCategories.filter(pt => pt !== 'Any')
    let categoriesQuery =
      filteredCategories.length > 1
        ? `primaryCategories:(${filteredCategories
            .map(pt => `"${pt}"`)
            .join(' OR ')})`
        : `primaryCategories:"${filteredCategories[0]}"`
    queryParts.push(categoriesQuery)
  }

  if (brandManufacturer) {
    let manufacturerQuery = `(brand:"${brandManufacturer}" OR manufacturer:"${brandManufacturer}")`
    queryParts.push(manufacturerQuery)
  }
  if (GTIN) {
    let GTINQuery = `gtins:${GTIN} OR upc:${GTIN}`
    queryParts.push(GTINQuery)
  }
  if (SKUS) {
    let SKUSQuery = `skus:"${SKUS}"`
    queryParts.push(SKUSQuery)
  }
  if (taxonomyLevel1) {
    let taxonomyLevel1Query = `taxonomyLevel1:"${taxonomyLevel1}"`
    queryParts.push(taxonomyLevel1Query)
  }
  if (taxonomyLevel2) {
    let taxonomyLevel2Query = `taxonomyLevel2:"${taxonomyLevel2}"`
    queryParts.push(taxonomyLevel2Query)
  }
  if (taxonomyLevel3) {
    let taxonomyLevel3Query = `taxonomyLevel3:"${taxonomyLevel3}"`
    queryParts.push(taxonomyLevel3Query)
  }
  if (rawCategory) {
    let rawCategoryQuery = `categories:"${rawCategory}"`
    queryParts.push(rawCategoryQuery)
  }

  if (rentalPrice) {
    const { minValue, maxValue } = rentalPrice

    if (minValue || maxValue) {
      let rentalPriceQuery = ''
      // Construct the range part of the query
      const minPart = minValue ? minValue : '*'
      const maxPart = maxValue ? maxValue : '*'
      rentalPriceQuery = `mostRecentPriceAmount:[${minPart} TO ${maxPart}]`
      queryParts.push(`${rentalPriceQuery}`)
    }
  }
  if (rentalPrice?.currency) {
    const { currency } = rentalPrice
    if (currency) {
      let rentalPriceCurrencyQuery = ''
      rentalPriceCurrencyQuery = `mostRecentPriceCurrency:${currency}`
      queryParts.push(`${rentalPriceCurrencyQuery}`)
    }
  }

  if (mostRecentPriceDate) {
    const { startDate, endDate } = mostRecentPriceDate
    let dateQuery = 'mostRecentPriceDate:'

    if (startDate || endDate) {
      const start = startDate ? startDate : '*'
      const end = endDate ? endDate : '*'
      dateQuery += `[${start} TO ${end}]`
      queryParts.push(dateQuery)
    }
  }

  if (description?.value) {
    const descriptionQuery = `descriptions.value:"${description.value}"`
    queryParts.push(descriptionQuery)
  }

  if (reviewsRangeQuery) {
    const { min, max } = reviewsRangeQuery
    if (min || max) {
      const minPart = min || '*'
      const maxPart = max || '*'
      const reviewsRangeQueryString = `reviews.rating:[${minPart} TO ${maxPart}]`
      queryParts.push(reviewsRangeQueryString)
    }
  }

  if (recordRecency) {
    const { dateAdded, dateUpdated } = recordRecency

    if (dateAdded) {
      const dateAddedQuery = `dateAdded:[${dateAdded} TO *]`
      queryParts.push(dateAddedQuery)
    }

    if (dateUpdated) {
      const dateUpdatedQuery = `dateUpdated:[${dateUpdated} TO *]`
      queryParts.push(dateUpdatedQuery)
    }
  }

  if (featureKeyword) {
    const { key, value } = featureKeyword

    if (key && value) {
      // Both key and value exist
      const featureKeywordQuery = `{features.key:"${key}" AND features.value:"${value}"}`
      queryParts.push(featureKeywordQuery)
    } else if (key) {
      // Only key exists
      const featureKeywordQuery = `features.key:"${key}"`
      queryParts.push(featureKeywordQuery)
    } else if (value) {
      // Only value exists
      const featureKeywordQuery = `features.value:"${value}"`
      queryParts.push(featureKeywordQuery)
    }
  }

  if (requiredFields && requiredFields.length > 0) {
    requiredFields.forEach(field => {
      queryParts.push(`${field}:*`)
    })
  }

  if (domain) {
    let domainQuery = `domains:"${domain}"`
    queryParts.push(domainQuery)
  }

  if (mostRecentPriceIsSale) {
    let mostRecentPriceIsSaleQuery = `mostRecentPriceIsSale:${mostRecentPriceIsSale}`
    queryParts.push(mostRecentPriceIsSaleQuery)
  }

  if (taxonomy) {
    let taxonomyQuery = `taxonomy:"${taxonomy}"`
    queryParts.push(taxonomyQuery)
  }

  if (price) {
    const { minValue, maxValue, currency } = price
    let priceQueryParts = []

    // Add minimum price condition if specified
    if (minValue) {
      priceQueryParts.push(`prices.amountMin:>=${minValue}`)
    }

    // Add maximum price condition if specified
    if (maxValue) {
      priceQueryParts.push(`prices.amountMin:<=${maxValue}`)
    }

    // Add currency condition if specified
    if (currency) {
      priceQueryParts.push(`prices.currency:${currency}`)
    }

    // Construct the final price query if conditions exist
    if (priceQueryParts.length > 0) {
      const priceQuery = `{${priceQueryParts.join(' AND ')}}`
      queryParts.push(priceQuery)
    }
  }

  if (priceWarranty) {
    queryParts.push('prices.warranty:*');
  }

  if (categoryWildCard) {
    let categoryWildCardQuery = `categories:${categoryWildCard}`
    queryParts.push(categoryWildCardQuery)
  }
  if (categoriesWithParenthesis) {
    let categoriesParenthesisQuery = `categories:(${categoriesWithParenthesis})`
    queryParts.push(categoriesParenthesisQuery)
  }
  if (color) {
    let colorQuery = `colors:"${color}"`
    queryParts.push(colorQuery)
  }
  if (featuresWithKey) {
    let featuresWithKeyQuery = `features.key:${featuresWithKey}`
    queryParts.push(featuresWithKeyQuery)
  }

  if (manufacturerNumber) {
    let manufacturerNumberQuery = `manufacturerNumber:"${manufacturerNumber}"`
    queryParts.push(manufacturerNumberQuery)
  }

  // Return the combined query or default if no parameters are set
  return queryParts.length > 0 ? queryParts.join(' AND ') : 'keys:*'
}

export default buildQuery
